import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ModalService } from '@app/shared/components/modal/modal.service';

@Component({
  selector: 'app-profile-base-modal',
  templateUrl: './profile-base-modal.component.html',
  styleUrls: ['./profile-base-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileBaseModalComponent implements OnInit, OnDestroy {
  @Input() modalId = '';
  @Input() modalTitle = '';
  @Input() modalSize: 'large' | 'small' = 'large';
  @Input() formGroup!: FormGroup;
  @Output() modalOnOpen = new EventEmitter();
  @Output() modalOnClose = new EventEmitter();

  private subscription = Subscription.EMPTY;

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.subscription = this.modalService.getModalState(this.modalId).subscribe((show) => {
      if (show) {
        this.modalOnOpen.emit();
      } else {
        this.modalOnClose.emit();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
